import { Typography, useTheme } from "@mui/material";
import RoundedCheck from "icons/RoundedCheck";
import { FC } from "react";
import {
  StyledPasswordPolicy,
  StyledPasswordPolicyIconContainer,
  StyledPasswordPolicyItem,
} from "styles/components/password-policy";

interface PasswordPolicyProps {
  listOfPolicy: {
    done: boolean;
    text: string;
  }[];
  dataTestId?: string;
}

const PasswordPolicy: FC<PasswordPolicyProps> = ({
  listOfPolicy,
  dataTestId,
}) => {
  const theme = useTheme();

  return (
    <StyledPasswordPolicy data-testid={dataTestId}>
      {listOfPolicy.map(({ text, done }) => (
        <StyledPasswordPolicyItem
          key={text}
          data-testid={dataTestId && `${dataTestId}-item`}
        >
          <StyledPasswordPolicyIconContainer
            data-testid={dataTestId && `${dataTestId}-icon`}
          >
            <RoundedCheck
              color={
                done ? theme.palette.green.dark : theme.palette.customGrey.dark
              }
              filled={done}
            />
          </StyledPasswordPolicyIconContainer>
          <Typography variant="bodyM" color={theme.palette.customGrey.dark}>
            {text}
          </Typography>
        </StyledPasswordPolicyItem>
      ))}
    </StyledPasswordPolicy>
  );
};

export default PasswordPolicy;
